import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';

const useUnsplashDownload = (
  downloadLocation?: string | null,
  trackUnsplashDownload?: boolean,
) => {
  useQuery(
    ['unsplash-download-tracker', downloadLocation, trackUnsplashDownload],
    () => {
      if (!downloadLocation) return Promise.resolve(undefined);
      if (!trackUnsplashDownload) return Promise.resolve(undefined);

      return backendService.instance.downloadUnsplashPhoto(downloadLocation);
    },
    {
      enabled: Boolean(downloadLocation && trackUnsplashDownload),
      staleTime: 1000 * 60 * 60,
    },
  );

  return {};
};

export default useUnsplashDownload;
